import React from "react";
import { withStyles } from "@material-ui/core/styles";
import numeral from "numeral";
// import { Card, CardHeader, CardContent, CardActions, Button } from "@material-ui/core";
import Card from "./Card/Card.jsx";
import CardHeader from "./Card/CardHeader.jsx";
import CardIcon from "./Card/CardIcon.jsx";
import CardBody from "./Card/CardBody.jsx";
import CardFooter from "./Card/CardFooter.jsx";
import DateRange from "@material-ui/icons/DateRange";


const styles = theme => ({
  successText: {
    color: "#4caf50"
  },
  upArrowCardCategory: {
    width: "16px",
    height: "16px"
  },
  stats: {
    color: "#999999",
    display: "inline-flex",
    fontSize: "12px",
    lineHeight: "22px",
    "& svg": {
      top: "4px",
      width: "16px",
      height: "16px",
      position: "relative",
      marginRight: "3px"
    }
  },
  cardCategory: {
    color: "#999999",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    paddingTop: "10px",
    paddingBottom:"10px",
    marginBottom: "0"
  },
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitle: {
    color: "#3C4858",
    marginTop: "0px",
    fontSize: "30px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  }
});

function getHeaderColor(value, shouldDisplayWarning) {

  if (shouldDisplayWarning === undefined) {
    return "info";
  }

  return shouldDisplayWarning(value) ?  "warning" : "info";
}

function formatNumber(value, format) {
  if (format === undefined) {
    return value;
  }

  return numeral(value).format(format);
}

const MeasureView = ({ icon, classes, label, subheader, value, shouldDisplayWarning, format }) => (
  <Card>
    <CardHeader color={getHeaderColor(value, shouldDisplayWarning)} stats icon>
      <CardIcon color={getHeaderColor(value, shouldDisplayWarning)}>
        {icon}
      </CardIcon>
      <p className={classes.cardCategory}>{label}</p>
      <h3 className={classes.cardTitle}>
        {formatNumber(value, format)}
      </h3>
    </CardHeader>
    <CardFooter stats>
      {/* <DateRange /> */}
      <div className={classes.stats}>
        {subheader}
      </div>
    </CardFooter>
  </Card>
);

export default withStyles(styles)(MeasureView);



// WEBPACK FOOTER //
// ./src/components/MeasureView.js